import { EmployeeNameDto } from '@app/_api/dto';
import { UUID } from '@app/_api/identifyable';

export type SuggestionAction =
  | { type: 'CREATE_SKILL'; title: string; parentId: UUID }
  | { type: 'MERGE_SKILL'; sourceSkillId: UUID; targetSkillId: UUID }
  | { type: 'MOVE_SKILL'; skillId: UUID; newParentId: UUID }
  | { type: 'DELETE_SKILL'; skillId: UUID; skillTitle: string }
  | { type: 'CHANGE_SKILL_TITLE'; skillId: UUID; oldTitle: string; newTitle: string }
  | { type: 'MERGE_CERTIFICATE'; sourceCertificateId: UUID; targetCertificateId: UUID; sourceCertificateTitle: string };

export interface SuggestionDto {
  id: UUID;
  employee?: EmployeeNameDto;
  action: SuggestionAction;
  reason?: string;
  createdAt: Date;
}

export interface SuggestionCreateDto {
  action: SuggestionAction;
  reason?: string;
}

export const getTillNow = (action: SuggestionAction, getSkillName: (skillId: UUID) => string) => {
  switch (action.type) {
    case 'CREATE_SKILL':
      return '';
    case 'MERGE_SKILL':
      return getSkillName(action.sourceSkillId);
    case 'MOVE_SKILL':
      return getSkillName(action.skillId);
    case 'DELETE_SKILL':
      return action.skillTitle;
    case 'CHANGE_SKILL_TITLE':
      return action.oldTitle;
    case 'MERGE_CERTIFICATE':
      return action.sourceCertificateTitle;
    default:
      return 'Fehler, nicht gefunden';
  }
};

export const getType = (action: SuggestionAction) => {
  const type = action.type;
  switch (type) {
    case 'CREATE_SKILL':
      return 'erstellen';
    case 'MERGE_SKILL':
      return 'fusionieren in';
    case 'MOVE_SKILL':
      return 'verschieben zu';
    case 'DELETE_SKILL':
      return 'löschen';
    case 'CHANGE_SKILL_TITLE':
      return 'Titel ändern zu';
    case 'MERGE_CERTIFICATE':
      return 'fusionieren in';
    default:
      return 'Fehler, nicht gefunden';
  }
};

export const getNew = (
  action: SuggestionAction,
  getSkillName: (skillId: UUID) => string,
  getCertificateName: (certificateId: UUID) => string,
) => {
  switch (action.type) {
    case 'CREATE_SKILL':
      return action.title;
    case 'MERGE_SKILL':
      return getSkillName(action.targetSkillId);
    case 'MOVE_SKILL':
      return getSkillName(action.newParentId);
    case 'DELETE_SKILL':
      return '';
    case 'CHANGE_SKILL_TITLE':
      return action.newTitle;
    case 'MERGE_CERTIFICATE':
      return getCertificateName(action.targetCertificateId);
    default:
      return 'Fehler, nicht gefunden';
  }
};

export type SuggestionResponse =
  | { type: 'NO_DATA' }
  | { type: 'CREATE_SKILL'; skillId: UUID }
  | { type: 'CHANGE_SKILL_TITLE' }
  | { type: 'MERGE_MOVE_DELETE_SKILL' }
  | { type: 'MERGE_CERTIFICATE' };
